import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AIMCQGenerator from "./AIMCQGenerator";
import TemplateGenerator from "./TemplateGenerator";
import ContentSuggestions from "./ContentSuggestions";
import AIAnalyticsDashboard from "./AIAnalyticsDashboard";
import AIConfigurationManager from "./AIConfigurationManager";
import AIQualityAnalytics from "./AIQualityAnalytics";
import AISmartEnhancement from "./AISmartEnhancement";
import { Brain, Sparkles, BarChart3, FileText, Settings, CheckCircle, Zap } from "lucide-react";

export default function AIManager() {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className="border-primary/20 bg-gradient-to-br from-background to-primary/5">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-sm">
              <Brain className="h-4 w-4 text-primary" />
              AI Content Generation
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-xs text-muted-foreground">
              Create medical MCQs and explanations using advanced AI
            </p>
          </CardContent>
        </Card>

        <Card className="border-warning/20 bg-gradient-to-br from-background to-warning/5">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-sm">
              <BarChart3 className="h-4 w-4 text-warning" />
              Content Analysis
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-xs text-muted-foreground">
              Quality assessment and improvement suggestions
            </p>
          </CardContent>
        </Card>

        <Card className="border-success/20 bg-gradient-to-br from-background to-success/5">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-sm">
              <Sparkles className="h-4 w-4 text-success" />
              Smart Tools
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-xs text-muted-foreground">
              Automated categorization and enhancement tools
            </p>
          </CardContent>
        </Card>
      </div>

      <Tabs defaultValue="mcq-generator" className="w-full">
        <TabsList className="grid w-full grid-cols-7">
          <TabsTrigger value="mcq-generator" className="flex items-center gap-2">
            <Brain className="h-4 w-4" />
            MCQ Gen
          </TabsTrigger>
          <TabsTrigger value="templates" className="flex items-center gap-2">
            <FileText className="h-4 w-4" />
            Templates
          </TabsTrigger>
          <TabsTrigger value="analysis" className="flex items-center gap-2">
            <BarChart3 className="h-4 w-4" />
            Analysis
          </TabsTrigger>
          <TabsTrigger value="quality" className="flex items-center gap-2">
            <CheckCircle className="h-4 w-4" />
            Quality
          </TabsTrigger>
          <TabsTrigger value="enhancement" className="flex items-center gap-2">
            <Zap className="h-4 w-4" />
            Enhancement
          </TabsTrigger>
          <TabsTrigger value="analytics" className="flex items-center gap-2">
            <BarChart3 className="h-4 w-4" />
            Analytics
          </TabsTrigger>
          <TabsTrigger value="settings" className="flex items-center gap-2">
            <Settings className="h-4 w-4" />
            Settings
          </TabsTrigger>
        </TabsList>

        <TabsContent value="mcq-generator" className="mt-6">
          <AIMCQGenerator />
        </TabsContent>

        <TabsContent value="templates" className="mt-6">
          <TemplateGenerator />
        </TabsContent>

        <TabsContent value="analysis" className="mt-6">
          <ContentSuggestions />
        </TabsContent>

        <TabsContent value="quality" className="mt-6">
          <AIQualityAnalytics />
        </TabsContent>

        <TabsContent value="enhancement" className="mt-6">
          <AISmartEnhancement />
        </TabsContent>

        <TabsContent value="analytics" className="mt-6">
          <AIAnalyticsDashboard />
        </TabsContent>

        <TabsContent value="settings" className="mt-6">
          <AIConfigurationManager />
        </TabsContent>
      </Tabs>
    </div>
  );
}